/**
 * タイトルを表します。
 */
export class CommonConst {

  /** お届け先区分 */
  public static readonly C_OTODOKESAKI_KUBUN_OTODOKESAKI: string = '1';
  public static readonly C_OTODOKESAKI_KUBUN_GEMBAIRE: string = '2';

  /** 商品区分 */
  public static readonly C_SHOHIN_KUBUN_YOGYO_HOKA: string = '0';
  public static readonly C_SHOHIN_KUBUN_KINZOKU: string = '1';
  public static readonly C_SHOHIN_KUBUN_ZENSHOHIN: string = '2';

  /** 商品種類（品柄） */
  public static readonly C_SHOHINSHURUI_HINGARA_HIMBAN: string = '1';
  public static readonly C_SHOHINSHURUI_HINGARA_GARAMEI: string = '2';

  /** 検索条件 */
  public static readonly C_KENSAKUJOKEN_MATAHA: string = '1';
  public static readonly C_KENSAKUJOKEN_KATSU: string = '2';

  /** 配送形態 */
  public static readonly C_HAISOKEITAI_MISEIRE: string = '1';
  public static readonly C_HAISOKEITAI_GEMBAIRE: string = '2';
  public static readonly C_HAISOKEITAI_HIKITORI: string = '3';

  /** 用途 */
  public static readonly C_YOTO_JUTAKU_SHINCHIKU: string = 'ES';
  public static readonly C_YOTO_JUTAKU_REFORM: string = 'RE';
  public static readonly C_YOTO_HIJUTAKU_SHINCHIKU: string = 'ET';
  public static readonly C_YOTO_HIJUTAKU_REFORM: string = 'RT';
  public static readonly C_YOTO_SONOTA: string = 'Z0';

  /** 積み順 */
  public static readonly C_TSUMIJUN_UE: string = '1';
  public static readonly C_TSUMIJUN_NAKA: string = '2';
  public static readonly C_TSUMIJUN_SHITA: string = '3';

  /** 自動追加行区分 */
  public static readonly C_JIDOTSUIKAGYO_KUBUN_NYURYOKU_GYO: string = '0';
  public static readonly C_JIDOTSUIKAGYO_KUBUN_JIDOTSUIKA_GYO: string = '1';

  /** 日付 */
  public static readonly C_HIZUKE_HATCHUBI: string = '1';
  public static readonly C_HIZUKE_SHUKKAKAKUTEIBI: string = '2';
  public static readonly C_HIZUKE_OTODOKEBI: string = '3';

  /** 発注方法 */
  public static readonly C_HATCHUHOHO_WEB: string = '1';
  public static readonly C_HATCHUHOHO_FAX: string = '2';

  /** お届け日状況 */
  public static readonly C_OTODOKEBI_JOKYO_NOKIMITEI: string = '1';
  public static readonly C_OTODOKEBI_JOKYO_NOKIOKURE: string = '2';
  public static readonly C_OTODOKEBI_JOKYO_TORIKESHI: string = '3';

  /** グループ区分 */
  public static readonly C_GURUPU_KUBUN_ICHIJITEN: string = '10';
  public static readonly C_GURUPU_KUBUN_NIJITEN: string = '20';
  public static readonly C_GURUPU_KUBUN_BUTSURYU_GAISHA: string = '30';
  public static readonly C_GURUPU_KUBUN_EIGYOSHO: string = '91';
  public static readonly C_GURUPU_KUBUN_BUTSURYU_CENTER: string = '92';
  public static readonly C_GURUPU_KUBUN_JUCHU_CENTER: string = '93';
  public static readonly C_GURUPU_KUBUN_EIGYOKIKAKUBU: string = '94';
  public static readonly C_GURUPU_KUBUN_BUTSURYUBU: string = '95';
  public static readonly C_GURUPU_KUBUN_SYSTEM_KANRISHA: string = '99';

  /** ユーザ連携区分*/
  public static readonly C_YUZA_RENKEI_KUBUN_NPN: string = '1';
  public static readonly C_YUZA_RENKEI_KUBUN_KIKAN: string = '2';

  /** メール送信結果 */
  public static readonly C_MAIL_SOSHINKEKKA_MAIL_SOSHIN_KANRYO: string = '0';
  public static readonly C_MAIL_SOSHINKEKKA_MAIL_SOSHIN_SHIPPAI: string = '90';
  public static readonly C_MAIL_SOSHINKEKKA_TEMPLATE_FILE_YOMIKOMI_SHIPPAI: string = '91';

  /** メール送信戻値 */
  public static readonly C_MAIL_SOSHINMODORICHI_SOSHIN_KANRYO: string = '0';
  public static readonly C_MAIL_SOSHINMODORICHI_PARAMETER_IJO: string = '8';
  public static readonly C_MAIL_SOSHINMODORICHI_SOSHIN_SHIPPAI: string = '9';

  /** リターンコード */
  public static readonly C_RTN_CODE_OK: string = '0';
  public static readonly C_RTN_CODE_API_NG1: string = '1';
  public static readonly C_RTN_CODE_API_NG2: string = '2';
  public static readonly C_RTN_CODE_API_NG3: string = '3';
  public static readonly C_RTN_CODE_API_NG4: string = '4';
  public static readonly C_RTN_CODE_COUNT_ZERO: string = '7';
  public static readonly C_RTN_CODE_NG: string = '8';
  public static readonly C_RTN_CODE_SYSTEM_ERR: string = '9';
  public static readonly C_RTN_CODE_HIKADOU: string = '10';
  public static readonly C_RTN_CODE_MENTETYU: string = '20';
  public static readonly C_RTN_CODE_TIMEOUT: string = '30';
  public static readonly C_RTN_CODE_LOGIN: string = '40';
  public static readonly C_RTN_CODE_NG_BROWSER = "50";

  /** 回収拠点区分 */
  public static readonly C_KAISHUKYOTEN_KUBUN_GEMBAKAISHU: string = '0';
  public static readonly C_KAISHUKYOTEN_KUBUN_SOKOKAISHU: string = '1';
  public static readonly C_KAISHUKYOTEN_KUBUN_SURUKYOTEN: string = '3';
  public static readonly C_KAISHUKYOTEN_KUBUN_SOKO: string = '4';
  public static readonly C_KAISHUKYOTEN_KUBUN_SONOTA: string = '5';

  /** 回収区分 */
  public static readonly C_KAISHU_KUBUN_PARETTOKAISHU: string = 'P';

  /** 日付チェック */
  public static readonly C_HIZUKE_CHECK_UKETSUKEBI: string = '0';
  public static readonly C_HIZUKE_CHECK_KAISHUKIBOBI: string = '1';
  public static readonly C_HIZUKE_CHECK_KAISHUKAKUTEIBI: string = '2';

  /** 回収状態区分 */
  public static readonly C_KAISHUJOTAI_KUBUN_IRAIZUMI: string = '0';
  public static readonly C_KAISHUJOTAI_KUBUN_KYANSERUZUMI: string = '1';
  public static readonly C_KAISHUJOTAI_KUBUN_KAISHUKAKUTEI: string = '2';
  public static readonly C_KAISHUJOTAI_KUBUN_KAISHUZUMI: string = '3';

  /** WHOカラム初期値 */
  public static readonly C_WHO_SHOKICHI_TANTOSHA: string = ' ';
  public static readonly C_WHO_SHOKICHI_PGM: string = ' ';
  public static readonly C_WHO_SHOKICHI_TAMMATSU_ID: string = ' ';
  public static readonly C_WHO_SHOKICHI_HIZUKE: string = '00010101';
  public static readonly C_WHO_SHOKICHI_JIKAN: string = '000101';
  public static readonly C_WHO_SHOKICHI_KOSHIMBANGO: number = 0;

  /** 輸送管理区分 */
  public static readonly C_YUSOKANRI_KUBUN_SURU: string = '1';

  /** 注文区分 */
  public static readonly C_THUMON_KUBUN_JUTEKKU_EDI: string = 'JT';
  public static readonly C_THUMON_KUBUN_NOITU_JUCHU: string = 'NT';
  public static readonly C_THUMON_KUBUN_MEWS: string = 'ME';

  /** 伝票発生区分 */
  public static readonly C_DENSO_HASSEI_KUBUN_NOUHINSHO_HAKKO_KOGUCHI: string = '01';
  public static readonly C_DENSO_HASSEI_KUBUN_DENPHO_HAKKO: string = '02';
  public static readonly C_DENSO_HASSEI_KUBUN_SHUKKA_NYURYOKU: string = '03';
  public static readonly C_DEMPYO_HASSEI_KUBUN_GYOSHA_CHOKUSO_NOHIN_NYURYOKU: string = '04';
  public static readonly C_DENSO_HASSEI_KUBUN_URIAGE_TEISEI_NEBIKI: string = '05';
  public static readonly C_DENSO_HASSEI_KUBUN_KAIGAI_SHUKKO_ICHIRAN: string = '06';
  public static readonly C_DENSO_HASSEI_KUBUN_SHUKKA_TORIKESHI: string = '07';
  public static readonly C_DENSO_HASSEI_KUBUN_SHUKKA_HENPIN: string = '08';
  public static readonly C_DENSO_HASSEI_KUBUN_URIAGE_NEBIKI: string = '09';
  public static readonly C_DENSO_HASSEI_KUBUN_RIBETO: string = '10';

  /** 返品状態区分 */
  public static readonly C_HENPINJYOUTAIKUBUN_IRAIZUMI: string = '0';
  public static readonly C_HENPINJYOUTAIKUBUN_KYANSERUZUMI: string = '1';
  public static readonly C_HENPINJYOUTAIKUBUN_SIJIZUMI: string = '2';
  public static readonly C_HENPINJYOUTAIKUBUN_SAKUJYOZUMI: string = '3';
  public static readonly C_HENPINJYOUTAIKUBUN_HIKITORIZUMI: string = '4';
  public static readonly C_HENPINJYOUTAIKUBUN_HENPINKANRYOU: string = '5';

  /** 指定納期基準区分 */
  public static readonly C_SHITEINOKIKIJUN_KUBUN_CHAKUBI_KIJUN: string = '1';
  public static readonly C_SHITEINOKIKIJUN_KUBUN_SHUKKABI_KIJUN: string = '2';

  /** 受注状態区分 */
  public static readonly C_JUCHUJOTAI_KUBUN_MISHUKKA: string = '0';
  public static readonly C_JUCHUJOTAI_KUBUN_KEIJOSUMI: string = '1';
  public static readonly C_JUCHUJOTAI_KUBUN_KYANSERUSUMI: string = '9';

  /** 引当区分 */
  public static readonly C_HIKIATE_KUBUN_SABISUHIN: string = '3';

  /** 決済 */
  public static readonly C_KESSAI_MUSHOHIN: string = '4A';

  /** 配送指定種類区分 */
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_TSUJO: string = '1';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_CHOKUSO: string = '2';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_SENTA_HIKITORI: string = '3';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_SURU_HIKITORI: string = '4';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_KOGUCHI: string = '5';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_KOGUCHI_SHITENDOME: string = '6';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_GYOSYA_CHOKUSO: string = '7';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_KOGUCHI_SENYO: string = '8';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_KAIGAI: string = '9';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_YUSO_HASON: string = 'Y';
  public static readonly C_HAISOSHITEI_SHURUI_KUBUN_KONAI_HASON: string = 'K';

  /** 分納不可区分 */
  public static readonly C_BUNNO_FUKA_KUBUN_BUNNO_KA: string = '0';
  public static readonly C_BUNNO_FUKA_KUBUN_BUNNO_FUKA: string = '1';
  public static readonly C_BUNNO_FUKA_KUBUN_SHITEI_BUNNO: string = '9';

  /** 指定納期区分 */
  public static readonly C_SHITEINOKI_KUBUN_SOKUNO: string = '1';
  public static readonly C_SHITEINOKI_KUBUN_HIZUKE_SHITEI: string = '2';
  public static readonly C_SHITEINOKI_KUBUN_MIKAKUTEI: string = '3';

  /** ノイツ非公開フラグ */
  public static readonly C_NOITS_HIKOKAI_FURAGU_SOKUNO: string = '0';
  public static readonly C_NOITS_HIKOKAI_FURAGU_HIZUKE_SHITEI: string = '1';

  /** 倉庫区分 */
  public static readonly C_SOKO_KUBUN_SOKO: string = '1';
  public static readonly C_SOKO_KUBUN_KOJO: string = '2';
  public static readonly C_SOKO_KUBUN_YUSYUTSUKO: string = '3';
  public static readonly C_SOKO_KUBUN_CHOKUSO: string = '4';

  /** 印刷区分 */
  public static readonly C_INSATSU_KUBUN_MIINSATSU: string = '1';
  public static readonly C_INSATSU_KUBUN_INSATSU: string = '2';

  /** 返品明細状態区分 */
  public static readonly C_HEMPIMMEISAIJOTAIKUBUN_IRAIZUMI: string = '0';
  public static readonly C_HEMPIMMEISAIJOTAIKUBUN_KYANSERUZUMI: string = '1';
  public static readonly C_HEMPIMMEISAIJOTAIKUBUN_SHIJIZUMI: string = '2';
  public static readonly C_HEMPIMMEISAIJOTAIKUBUN_SAKUJO: string = '3';
  public static readonly C_HEMPIMMEISAIJOTAIKUBUN_HIKITORIZUMI: string = '4';
  public static readonly C_HEMPIMMEISAIJOTAIKUBUN_HEMPINKANRYO: string = '5';

  /** 出力区分 */
  public static readonly C_SHUTSURYOKUKUBUN_KOBETSU: string = '1';
  public static readonly C_SHUTSURYOKUKUBUN_IKKATSUCHOKKIMBUN: string = '2';
  public static readonly C_SHUTSURYOKUKUBUN_IKKATSUKAKOBUN: string = '3';

  /** 受注対象メンテ区分 */
  public static readonly C_JUCHU_TAISHO_MENTE_KUBUN_IROSHITEI: string = 'C';
  public static readonly C_JUCHU_TAISHO_MENTE_KUBUN_SUMITOMO: string = 'R';
  public static readonly C_JUCHU_TAISHO_MENTE_KUBUN_KINZOKU: string = 'K';
  public static readonly C_JUCHU_TAISHO_MENTE_KUBUN_MAEDAOSHI: string = 'G';

  /** 金属区分 */
  public static readonly C_KINZOKU_KUBUN_KINZOKUIGAI: string = '0';
  public static readonly C_KINZOKU_KUBUN_KINZOKU: string = '1';

  /** 回収明細状態区分 */
  public static readonly C_KAISHUMEISAIJOTAI_IRAIZUMI: string = '0';
  public static readonly C_KAISHUMEISAIJOTAI_KYANSERUZUMI: string = '1';
  public static readonly C_KAISHUMEISAIJOTAI_KAISHUKAKUTEI: string = '2';
  public static readonly C_KAISHUMEISAIJOTAI_KAISHUZUMI: string = '3';

  /** API処理コード */
  public static readonly C_API_SHORI_KODO_SEIJO: string = '0';
  public static readonly C_API_SHORI_KODO_RIYO_FUKA: string = '1';
  public static readonly C_API_SHORI_KODO_RIKUESUTO_ERA: string = '2';
  public static readonly C_API_SHORI_KODO_GYOMU_ERA: string = '3';
  public static readonly C_API_SHORI_KODO_KIKAN_ERA: string = '4';
  public static readonly C_API_SHORI_KODO_SYSTEM_ERA: string = '9';

  /** お問い合わせ区分 */
  public static readonly C_OTOIAWASEKUBUN_SOUSA: string = '1';
  public static readonly C_OTOIAWASEKUBUN_FUGUAI: string = '2';
  public static readonly C_OTOIAWASEKUBUN_GOIKEN: string = '3';
  public static readonly C_OTOIAWASEKUBUN_SONOTA: string = '4';

  /** 基幹プロシージャ処理結果 */
  public static readonly C_KIKAN_PROC_KEKKA_SEIJO: string = '0';

  /** 製品商品区分 */
  public static readonly C_SEIHINSHOHINKUBUN_KATAROGUHIN: string = '2';
  public static readonly C_SEIHINSHOHINKUBUN_HIKATAROGUHIN: string = '3';

  /** 寸法自動表示区分 */
  public static readonly C_SUMPOJIDOHYOJIKUBUN_TAISHO: string = '1';

  /** 品番区分 */
  public static readonly C_HIMBANKUBUN_NEBIKI: string = '7';

  /** 資材区分 */
  public static readonly C_SHIZAIKUBUN_SHOHIN_SEIHIN_HANSEIHIN: string = '0';

  /** 論理削除フラグ */
  public static readonly C_RONRISAKUJOFURAGU_KADOCHU: string = '0';

  /** 受注対象外メンテ区分 */
  public static readonly C_JUCHUTAISHOGAIMENTEKUBUN_NOITSU: string = 'N';

  /** 申請状態区分 */
  public static readonly C_SHINSEIJOTAIKUBUN_MISHONIN: string = '0';
  public static readonly C_SHINSEIJOTAIKUBUN_SHONIN: string = '1';
  public static readonly C_SHINSEIJOTAIKUBUN_HININ: string = '2';
  public static readonly C_SHINSEIJOTAIKUBUN_KANRYO: string = '3';

  /** 受注単価入力区分 */
  public static readonly C_JUCHU_TANKA_NYURYOKU_KUBUN_URI_TANKA: string = '1';
  public static readonly C_JUCHU_TANKA_NYURYOKU_KUBUN_TOROKU_TANKA: string = '2';
  public static readonly C_JUCHU_TANKA_NYURYOKU_KUBUN_TOROKU_TANKA_GAIKA: string = '3';
  public static readonly C_JUCHU_TANKA_NYURYOKU_KUBUN_KAKERITSU: string = '4';
  public static readonly C_JUCHU_TANKA_NYURYOKU_KUBUN_CHOKUSETSU: string = '5';
  public static readonly C_JUCHU_TANKA_NYURYOKU_KUBUN_TOROKU_TANKA_EDI: string = '6';
  public static readonly C_JUCHU_TANKA_NYURYOKU_KUBUN_HYOKA_TANKA_GENKA: string = 'A';

  /** ロール区分 */
  public static readonly C_RORUKUBUN_YUZAKOBETSUSETTEI: string = '1';
  public static readonly C_RORUKUBUN_GURUPURORU: string = '2';

  /** 印刷状況区分 */
  public static readonly C_INSATSUJOTAIKUBUN_MIINSATSU: string = '1';
  public static readonly C_INSATSUJOTAIKUBUN_INSATSU: string = '2';

  /** 進捗状況 */
  public static readonly C_SHINCHOKUJOKYO_SHIJIOFUHIKITORIOFU: string = '0';
  public static readonly C_SHINCHOKUJOKYO_SHIJIONHIKITORIOFU: string = '1';
  public static readonly C_SHINCHOKUJOKYO_SHIJIOFUHIKITORION: string = '2';
  public static readonly C_SHINCHOKUJOKYO_SHIJIONHIKITORION: string = '3';

  /** 納品先区分 */
  public static readonly C_NOHISAKI_KUBUN_TOKUYAKUTEN: string = '1';
  public static readonly C_NOHISAKI_KUBUN_HANBAITEN: string = '2';
  public static readonly C_NOHISAKI_KUBUN_GEMBA: string = '3';
  public static readonly C_NOHISAKI_KUBUN_HIKITORI: string = '4';
  public static readonly C_NOHISAKI_KUBUN_SONOTA_MISE: string = '5';
  public static readonly C_NOHISAKI_KUBUN_SONOTA: string = '6';

  /** カテゴリ */
  public static readonly C_KATEGORI_TOKUYAKUTEN: string = '10';
  public static readonly C_KATEGORI_OTOKUISAKI: string = '20';
  public static readonly C_KATEGORI_BUTURYUKAISHA: string = '30';

  /** チェックボックス　ON OFF */
  public static readonly C_CHECKBOX_ON: string = '1';
  public static readonly C_CHECKBOX_OFF: string = '0';

  /** エラーの背景色 */
  //public static readonly C_ERROR_COLOR: string = '#ff7c80';
  public static readonly C_ERROR_COLOR: string = '#ffaaaa';     // これに変える

  /** Enabledの背景色 */
  public static readonly C_ENABLED_COLOR: string = '#eeeeee';

  /** ― */
  public static readonly C_DASSHU: string = '―';

  /** システムのタイトル */
  public static readonly TITLE_SYSTEM: string = ' | Nichiha Port Net';

  public static readonly TITLE_N2011: string = '商品・在庫照会';
  public static readonly TITLE_N2012: string = '発注予定リスト確認';
  public static readonly TITLE_N2013: string = '関連部材選択';
  public static readonly TITLE_N2014: string = '在庫詳細表示';

  public static readonly TITLE_N2021: string = '発注入力';
  public static readonly TITLE_N2022: string = '発注確認';
  public static readonly TITLE_N2023: string = '発注完了';
  public static readonly TITLE_N2024: string = '希望車種選択';

  public static readonly TITLE_N2031: string = '発注状況照会';
  public static readonly TITLE_N2032: string = '発注詳細';

  public static readonly TITLE_N2041: string = '発注内容変更';
  public static readonly TITLE_N2042: string = '発注訂正確認';
  public static readonly TITLE_N2043: string = '発注内容変更完了';
  public static readonly TITLE_N2044: string = '発注キャンセル確認';

  public static readonly TITLE_N2051: string = 'お買い上げ明細照会';
  public static readonly TITLE_N2052: string = '発注詳細';

  public static readonly TITLE_N2061: string = '出荷明細書一括ダウンロード';

  public static readonly TITLE_N2071: string = '出荷明細データ２ダウンロード';

  public static readonly TITLE_N3011: string = '配送情報参照';
  public static readonly TITLE_N3012: string = '配送情報参照詳細';

  public static readonly TITLE_N3021: string = '配送時間個別仮登録';
  public static readonly TITLE_N3022: string = '配送時間仮登録詳細';
  public static readonly TITLE_N3023: string = '配送時間一括仮登録';
  public static readonly TITLE_N3024: string = '配送時間一括仮登録確認';
  public static readonly TITLE_N3025: string = '配送時間一括仮登録完了';
  public static readonly TITLE_N3026: string = 'その他帳票出力ダイアログ';

  public static readonly TITLE_N3031: string = '配送時間本登録';
  public static readonly TITLE_N3032: string = '配送時間本登録完了';

  public static readonly TITLE_N3061: string = '返品引取情報参照';
  public static readonly TITLE_N3062: string = '返品引取情報更新';
  public static readonly TITLE_N3063: string = '返品引取情報完了';

  public static readonly TITLE_N3071: string = 'パレット回収情報参照';
  public static readonly TITLE_N3072: string = 'パレット回収情報更新';
  public static readonly TITLE_N3073: string = 'パレット回収情報完了';
  public static readonly TITLE_N3074: string = '回収ルート選択';

  public static readonly TITLE_N4011: string = '同意画面';
  public static readonly TITLE_N4012: string = 'ユーザ登録依頼';
  public static readonly TITLE_N4013: string = 'ユーザ登録依頼結果';

  public static readonly TITLE_N4021: string = 'ユーザ登録依頼一覧';
  public static readonly TITLE_N4022: string = 'ユーザ登録依頼詳細';
  public static readonly TITLE_N4023: string = 'ユーザ登録依頼承認結果';

  public static readonly TITLE_N4031: string = 'ユーザ登録';
  public static readonly TITLE_N4032: string = 'ユーザ登録結果';

  public static readonly TITLE_N4041: string = 'ユーザ管理一覧';
  public static readonly TITLE_N4042: string = 'ユーザ管理入力';
  public static readonly TITLE_N4043: string = 'ユーザ管理結果';

  public static readonly TITLE_N4051: string = 'ユーザ情報設定';
  public static readonly TITLE_N4052: string = 'ユーザ情報結果';

  public static readonly TITLE_N4061: string = 'パスワード再発行';
  public static readonly TITLE_N4062: string = 'パスワード再発行結果';

  public static readonly TITLE_N4071: string = 'お知らせ管理';
  public static readonly TITLE_N4072: string = 'お知らせ登録／更新';
  public static readonly TITLE_N4073: string = 'お知らせ登録／更新確認';
  public static readonly TITLE_N4074: string = '公開対象選択';

  public static readonly TITLE_N4081: string = '代行ユーザ一覧';

  public static readonly TITLE_N4091: string = '方面登録';
  public static readonly TITLE_N4092: string = '方面登録確認';
  public static readonly TITLE_N4093: string = '方面登録完了';

  public static readonly TITLE_N5011: string = 'ログイン';
  public static readonly TITLE_N5012: string = '二段階認証';

  public static readonly TITLE_N5021: string = 'ホーム';
  public static readonly TITLE_N5022: string = 'ホーム';
  public static readonly TITLE_N5023: string = 'ホーム';

  public static readonly TITLE_N5031: string = 'お問い合わせ入力';
  public static readonly TITLE_N5032: string = 'お問い合わせ確認';

  public static readonly TITLE_N5111: string = '配送ルート選択';


  public static readonly PGM_N5111_MAX_COUNT: number = 5;

  public static readonly SQL_EIGYOSHOMEI: string = 'sqlMapCommon.selectEigyoshomeiData';

  public static readonly PAGE_NO_1: number = 1;

  // 画面ID
  public static readonly PGM_N2011: string = "N2011";
  public static readonly PGM_N2012: string = "N2012";
  public static readonly PGM_N2021: string = "N2021";
  public static readonly PGM_N2022: string = "N2022";
  public static readonly PGM_N2023: string = "N2023";
  public static readonly PGM_N2042: string = "N2042";
  public static readonly PGM_N2031: string = "N2031";
  public static readonly PGM_N2051: string = "N2051";
  public static readonly PGM_N2061: string = "N2061";
  public static readonly PGM_N2071: string = "N2071";
  public static readonly PGM_N3011: string = "N3011";
  public static readonly PGM_N3012: string = "N3012";
  public static readonly PGM_N3021: string = "N3021";
  public static readonly PGM_N3022: string = "N3022";
  public static readonly PGM_N3023: string = "N3023";
  public static readonly PGM_N3024: string = "N3024";
  public static readonly PGM_N3025: string = "N3025";
  public static readonly PGM_N3031: string = "N3031";
  public static readonly PGM_N3032: string = "N3032";
  public static readonly PGM_N3061: string = "N3061";
  public static readonly PGM_N3062: string = "N3062";
  public static readonly PGM_N3063: string = "N3063";
  public static readonly PGM_N3071: string = "N3071";
  public static readonly PGM_N3072: string = "N3072";
  public static readonly PGM_N3073: string = "N3073";
  public static readonly PGM_N4021: string = "N4021";
  public static readonly PGM_N4031: string = "N4031";
  public static readonly PGM_N4032: string = "N4032";
  public static readonly PGM_N4041: string = "N4041";
  public static readonly PGM_N4042: string = "N4042";
  public static readonly PGM_N4043: string = "N4043";
  public static readonly PGM_N4051: string = "N4051";
  public static readonly PGM_N4052: string = "N4052";
  public static readonly PGM_N4071: string = "N4071";
  public static readonly PGM_N4072: string = "N4072";
  public static readonly PGM_N4073: string = "N4073";
  public static readonly PGM_N4081: string = "N4081";
  public static readonly PGM_N4091: string = "N4091";
  public static readonly PGM_N4092: string = "N4092";
  public static readonly PGM_N4093: string = "N4093";
  public static readonly PGM_N5021: string = "N5021";
  public static readonly PGM_N50212: string = "N50212";
  public static readonly PGM_N5031: string = "N5031";
  public static readonly PGM_N5032: string = "N5032";

  public static readonly C_NPN_BLACK: string = " ";
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/const/common-const.ts